import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-delete\"><path d=\"M783.530667 723.2l-60.330667 60.330667L512 572.330667 300.8 783.530667l-60.416-60.330667L451.669333 512 240.384 300.885333l60.416-60.416L512 451.669333l211.2-211.2 60.330667 60.416L572.330667 512l211.2 211.2zM512 0a512 512 0 1 0 0 1024A512 512 0 0 0 512 0z\" fill=\"#8a8a8a\" p-id=\"2866\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol